import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/privacy')({
  component: Privacy,
});

function Privacy() {
  return (
    <div className="mt-12 flex flex-col items-center px-4 pb-16">
      <img
        src="https://storage.googleapis.com/mideoid-console-public/logos/MIDEOhealth.png"
        alt="mideo_logo"
        className="h-36 mb-8"
      />

      <article className="max-w-4xl w-full prose prose-slate lg:prose-lg">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy</h1>

        <p className="text-gray-700 leading-relaxed mb-4">
          Video Directives, LLC built the MIDEO app as a Free downloadable app. This SERVICE is provided by Video Directives, LLC and is intended for use as is.
        </p>

        <p className="text-gray-700 leading-relaxed mb-4">
          This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.
        </p>

        <p className="text-gray-700 leading-relaxed mb-4">
          If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.
        </p>

        <p className="text-gray-700 leading-relaxed mb-6">
          The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at mideohealth.com unless otherwise defined in this Privacy Policy.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Information Collection and Use</h2>

        <p className="text-gray-700 leading-relaxed mb-6">
          For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to name, address, phone number, healthcare information. The information that we request will be retained by us and used as described in this privacy policy.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Log Data</h2>

        <p className="text-gray-700 leading-relaxed mb-6">
          We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (&quot;IP&quot;) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Cookies</h2>

        <p className="text-gray-700 leading-relaxed mb-4">
          Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device&apos;s internal memory.
        </p>

        <p className="text-gray-700 leading-relaxed mb-6">
          This Service does not use these &quot;cookies&quot; explicitly. However, the app may use third party code and libraries that use &quot;cookies&quot; to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Service Providers</h2>

        <p className="text-gray-700 leading-relaxed mb-3">
          We may employ third-party companies and individuals due to the following reasons:
        </p>

        <ul className="list-disc pl-6 mb-4 text-gray-700 space-y-2">
          <li>To facilitate our Service;</li>
          <li>To provide the Service on our behalf;</li>
          <li>To perform Service-related services; or</li>
          <li>To assist us in analyzing how our Service is used.</li>
        </ul>

        <p className="text-gray-700 leading-relaxed mb-6">
          We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Security</h2>

        <p className="text-gray-700 leading-relaxed mb-6">
          We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Links to Other Sites</h2>

        <p className="text-gray-700 leading-relaxed mb-6">
          This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Children&apos;s Privacy</h2>

        <p className="text-gray-700 leading-relaxed mb-6">
          These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13 years of age. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Changes to This Privacy Policy</h2>

        <p className="text-gray-700 leading-relaxed mb-4">
          We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page.
        </p>

        <p className="text-gray-700 leading-relaxed mb-6">
          This policy is effective as of 2021-10-19
        </p>

        <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">Contact Us</h2>

        <p className="text-gray-700 leading-relaxed">
          If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at info@mideohealth.com.
        </p>
      </article>
    </div>
  );
}
